<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="30">mdi-math-log</v-icon>
      </div>

      <span class="main-toolbar-title">{{ $t('Relatórios - Logs') }}</span>

      <v-spacer></v-spacer>
    </div>

    <v-form ref="form" class="d-flex">
      <v-row class="ma-0">
        <v-col cols="12" sm="4" class="ma-0">
          <v-autocomplete
            :label="$t('Instituição')"
            hide-details
            v-model="filter.institutionId"
            :items="institutions"
            append-icon="mdi-chevron-down"
            item-value="id"
            item-text="name"
            :loading="institutionLoading"
            outlined
            class="primary-input ma-1"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="8" class="ma-0 mt-1">
          <v-row class="ma-0" no-gutters>
            <v-col cols="12" sm="6">
              <v-menu
                ref="menuStartDate"
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    clearable
                    hide-details="auto"
                    v-model="startDate"
                    placeholder="Data inicial"
                    v-mask="['##/##/####']"
                    prepend-inner-icon="mdi-calendar"
                    @blur="calledStartDate = parseDate(startDate)"
                    v-bind="attrs"
                    v-on="on"
                    autocomplete="off"
                    outlined
                    class="primary-input mr-2"
                    @keyup.enter="list"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="calledStartDate"
                  min="1900-01-01"
                  @change="save"
                  locale="pt"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                ref="menuEndDate"
                v-model="menuEndDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    clearable
                    hide-details="auto"
                    placeholder="Data final"
                    :disabled="!startDate"
                    v-model="endDate"
                    v-mask="['##/##/####']"
                    prepend-inner-icon="mdi-calendar"
                    @blur="calledEndDate = parseDate(endDate)"
                    v-bind="attrs"
                    v-on="on"
                    name="endDate"
                    autocomplete="off"
                    outlined
                    class="primary-input mr-2"
                    @keyup.enter="list"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="calledEndDate"
                  @change="save"
                  locale="pt"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-btn
        color="#BBCF20"
        dark
        depressed
        class="ml-3 mt-4 hidden-sm-and-down primary-button"
        @click="list"
      >
        Filtrar
      </v-btn>
    </v-form>

    <v-data-table
      class="main-table"
      hide-default-footer
      :loading="loading"
      :items="items"
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhum log encontrado')"
      :headers="headers"
      hide-default-header
      :items-per-page="filter.pageSize"
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.timeStamp`]="{ item }">
        {{ item.timeStamp ? formatDate(item.timeStamp) : $t('Sem registros') }}
      </template>

      <template #[`item.username`]="{ item }">
        {{
          item.username && item.username.includes('{')
            ? JSON.parse(item.username).Email
            : !item.username.includes('{')
            ? item.username
            : $t('Sem registros')
        }}
      </template>

      <template #[`item.changes`]="{ item }">
        {{
          item.changes
            ? getInst(item.changes.InstitutionId, item.institutionId)
            : $t('Sem registros')
        }}
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="items.length">
          <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import moment from 'moment'

export default {
  name: 'LogsPage',

  async mounted() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id

    this.startDate = moment().subtract(7, 'days').format('DD/MM/yyyy')
    this.endDate = moment().format('DD/MM/yyyy')
    this.filter.startDate = this.startDate
    this.filter.endDate = this.endDate

    this.calledStartDate = this.parseDate(this.startDate)
    this.calledEndDate = this.parseDate(this.endDate)

    await this.getInstitutions()
    this.list()
  },

  data() {
    return {
      startDate: null,
      endDate: null,
      calledEndDate: null,
      calledStartDate: null,
      menuStartDate: false,
      menuEndDate: false,
      minDate: null,

      pageSize: 10,
      page: 1,
      filter: {
        startDate: null,
        endDate: null,
        page: 1,
        totalItems: 0,
        totalPages: 0,
        pageSize: 10,
      },
      items: [],
      sizes: [10, 30, 90, 180],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Entidade',
          align: 'center',
          value: 'translatedEntityName',
        },
        {
          text: 'Tipo',
          align: 'center',
          value: 'actionType',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'timeStamp',
        },
        {
          text: 'Usuário',
          align: 'center',
          value: 'username',
        },
        {
          text: 'Instituição',
          align: 'center',
          value: 'changes',
        },
      ],
      loading: false,
      apiService: new ApiService(),
      institutionLoading: false,
      institutions: [],
    }
  },
  methods: {
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.calledStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calledStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.calledEndDate)
      this.$refs.menuEndDate.save(date)
    },

    getInst(id, otherId) {
      if (id) {
        const inst = this.institutions.find((x) => x.id == id)
        return inst ? inst.name : 'Sem registro'
      } else if (otherId) {
        const inst = this.institutions.find((x) => x.id == otherId)
        return inst ? inst.name : 'Sem registro'
      }
    },

    formatDate(date) {
      return moment(date).format('DD/MM/yyyy HH:mm')
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutions.unshift({
            name: 'Registros sem vínculo direto com instituição',
            id: null,
          })
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    list() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.filter.startDate = this.calledStartDate
        this.filter.endDate = this.calledEndDate
        this.apiService
          .post('logs/list', this.filter)
          .then((response) => {
            this.items = response.content.data
            this.filter.totalPages = response.content.pager.totalPages
            this.filter.totalItems = response.content.pager.totalItems
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style scoped></style>
